import {isFeatureEnabled} from '@github-ui/feature-flags'
import {TransactionalMessageBanner} from '@github-ui/in-product-targeting'
import type {HeaderPageData} from '../../page-data/payloads/header'
import {ReviewRequestBanner} from './ReviewRequestBanner'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import type {PullRequestAppPayload} from '../../page-data/payloads/pull-request-app'
import type {PullRequestActiveRoute} from '../../hooks/use-active-route'

interface PullRequestsTopBannersProps extends Pick<HeaderPageData, 'bannersData' | 'urls'> {
  activeRoute: PullRequestActiveRoute
}

export function PullRequestsTopBanners({bannersData, urls, activeRoute}: PullRequestsTopBannersProps) {
  const {transactionalMessageBanner} = useAppPayload<PullRequestAppPayload>()
  const showTransactionalMessageBanner =
    isFeatureEnabled('ipm_global_transactional_message_prs') && transactionalMessageBanner

  const showReviewRequestBanner = activeRoute === 'conversation' && bannersData.banners.reviewRequestBanner.render

  const hasBanners = showTransactionalMessageBanner || showReviewRequestBanner

  if (!hasBanners) {
    return null
  }

  return (
    <div className={'d-flex flex-column gap-2 tmp-mb-3'}>
      {showTransactionalMessageBanner ? <TransactionalMessageBanner banner={transactionalMessageBanner} /> : null}
      {showReviewRequestBanner && (
        <ReviewRequestBanner reviewRequest={bannersData.banners.reviewRequestBanner} urls={urls} />
      )}
    </div>
  )
}
